module.exports = __webpack_public_path__ + "static/media/in_control.8dc71923.mp4";